"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapperType = exports.AssetDataSource = exports.UtxoAccountType = exports.WithdrawType = exports.NetworkTypes = exports.ChainTypes = void 0;
var ChainTypes;
(function (ChainTypes) {
    ChainTypes["Ethereum"] = "ethereum";
    ChainTypes["Bitcoin"] = "bitcoin";
    ChainTypes["Cosmos"] = "cosmos";
    ChainTypes["Osmosis"] = "osmosis";
})(ChainTypes = exports.ChainTypes || (exports.ChainTypes = {}));
var NetworkTypes;
(function (NetworkTypes) {
    NetworkTypes["MAINNET"] = "MAINNET";
    NetworkTypes["TESTNET"] = "TESTNET";
    NetworkTypes["ETH_ROPSTEN"] = "ETH_ROPSTEN";
    NetworkTypes["ETH_RINKEBY"] = "ETH_RINKEBY";
    NetworkTypes["COSMOSHUB_MAINNET"] = "COSMOSHUB_MAINNET";
    NetworkTypes["COSMOSHUB_VEGA"] = "COSMOSHUB_VEGA";
    NetworkTypes["OSMOSIS_MAINNET"] = "OSMOSIS_MAINNET";
    NetworkTypes["OSMOSIS_TESTNET"] = "OSMOSIS_TESTNET";
})(NetworkTypes = exports.NetworkTypes || (exports.NetworkTypes = {}));
var WithdrawType;
(function (WithdrawType) {
    WithdrawType[WithdrawType["DELAYED"] = 0] = "DELAYED";
    WithdrawType[WithdrawType["INSTANT"] = 1] = "INSTANT";
})(WithdrawType = exports.WithdrawType || (exports.WithdrawType = {}));
var UtxoAccountType;
(function (UtxoAccountType) {
    UtxoAccountType["SegwitNative"] = "SegwitNative";
    UtxoAccountType["SegwitP2sh"] = "SegwitP2sh";
    UtxoAccountType["P2pkh"] = "P2pkh";
})(UtxoAccountType = exports.UtxoAccountType || (exports.UtxoAccountType = {}));
// TODO(0xdef1cafe): remove this, client should not be aware of where data is from
// Describes the data source for where to get the asset details or asset description.
var AssetDataSource;
(function (AssetDataSource) {
    AssetDataSource["CoinGecko"] = "coingecko";
    AssetDataSource["YearnFinance"] = "yearnfinance";
})(AssetDataSource = exports.AssetDataSource || (exports.AssetDataSource = {}));
// swapper
var SwapperType;
(function (SwapperType) {
    SwapperType["Zrx"] = "0x";
    SwapperType["Thorchain"] = "Thorchain";
    SwapperType["Test"] = "Test";
})(SwapperType = exports.SwapperType || (exports.SwapperType = {}));
